import {useTranslation} from "react-i18next";
import React, {useContext, useState} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import {useNavigate} from "react-router-dom";
import IdentityImage from "../../components/IdentityImage.jsx";
import DeleteProjectYesNo from "../project/DeleteProjectYesNo.jsx";
import PlanName from "../project/Subscription/PlanName.jsx";
import ActionButton from "../../components/ActionButton.jsx";
import {formatDateTimeLabel} from "../admin/ReportingLab.jsx";

export default function UserProjectItem({project, onProjectIdSelected}) {

    let {t} = useTranslation();
    let {context} = useContext(GlobalContext);

    let navigate = useNavigate();

    let [deletePressed, setDeletePressed] = useState(false);

    const subscriptionCode = project?.subscription?.currentPackage?.code;

    return (
        <tr>
            <td className="min-w-64">
                <button type="button" className="flex min-w-0 items-center text-left" onClick={() => onProjectIdSelected(project.id)}>
                    <IdentityImage
                        url={project.logoUrl}
                        project={project}
                        className="mr-3 ring-2 ring-white dark:ring-slate-800"
                    />
                    <span className="min-w-0">
                        <span className="block truncate font-semibold text-slate-900 dark:text-white">
                        {project.name}
                        </span>
                        {context.currentProjectId === project.id && <span className="mt-1 inline-flex rounded-full bg-violet-50 px-2 py-0.5 text-xs font-medium text-violet-700 dark:bg-violet-500/15 dark:text-violet-300">
                            {t('projects.currently-selected')}
                        </span>}
                    </span>
                </button>
            </td>
            <td className="whitespace-nowrap">
                <PlanName
                    planCode={subscriptionCode}
                    withoutSubscription={!project?.subscription}
                    className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600 dark:bg-slate-700 dark:text-slate-300"
                />
            </td>
            <td className="whitespace-nowrap text-right text-sm text-slate-600 dark:text-slate-300">
                {formatDateTimeLabel(project.lastInteraction, false)}
            </td>
            <td className="w-28">
                <DeleteProjectYesNo
                    visible={deletePressed}
                    setVisible={setDeletePressed}
                    project={project}
                />

                <div className="flex justify-end gap-1">

                    {context.currentProjectId !== project.id &&
                        <ActionButton
                            icon={'check'}
                            title={t('project.select')}
                            onClick={() => onProjectIdSelected(project.id)}
                        />
                    }

                    <ActionButton
                        icon={'pencil'}
                        title={t('route.project-settings')}
                        onClick={() => navigate('/project/' + project.id + '/settings')}
                    />

                    <ActionButton
                        icon={'trash'}
                        variant={'primary-red'}
                        title={t('project.delete')}
                        onClick={() => setDeletePressed(true)}
                    />
                </div>
            </td>
        </tr>
    );
}
